define('sc_cct_html.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('sc_cct_html', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div> "
    + ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"hasHtmlString") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":6},"end":{"line":1,"column":52}}})) != null ? stack1 : "")
    + " </div> ";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return " "
    + ((stack1 = ((helper = (helper = _nl_(helpers,"htmlString") || (depth0 != null ? _nl_(depth0,"htmlString") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"htmlString","hash":{},"data":data,"loc":{"start":{"line":1,"column":28},"end":{"line":1,"column":44}}}) : helper))) != null ? stack1 : "")
    + " ";
},"useData":true}, 'extensions/AnchorGroup/Manor/3.5.3/', 'extensions/AnchorGroup/Manor/3.5.3/', Handlebars);
});